module.exports = __webpack_public_path__ + "static/ea-logo-3a6083ab988a06822d3510dbbb95a07d.svg";